import { Icon, InputRightElement, Tooltip } from '@podiumhq/design-system';

const CreditCardFieldRightElement = ({
  error,
  iconType,
  tooltipIcon = 'QuestionMark',
  tooltipLabel,
}) => {
  return !error && tooltipLabel ? (
    <Tooltip
      closeOnClick={true}
      label={tooltipLabel}
      openDelay={0}
      placement="top"
    >
      <InputRightElement>
        <Icon
          sx={{ svg: { fill: 'grey.light' } }}
          size="sm"
          type={tooltipIcon}
          variant="ghost"
        />
      </InputRightElement>
    </Tooltip>
  ) : iconType || error ? (
    <InputRightElement>
      {error ? (
        <Icon
          sx={{ svg: { fill: 'red.base' } }}
          size="sm"
          type="AlertCircle"
          variant="ghost"
        />
      ) : (
        iconType && (
          <Icon
            color="grey.lighter"
            size="sm"
            type={iconType}
            variant="ghost"
          />
        )
      )}
    </InputRightElement>
  ) : null;
};

export default CreditCardFieldRightElement;
